const EventEmitter = require('events');

export const eventEmitter = new EventEmitter();
export default EventEmitter;
